import AppSelect from '@nxsys/components/AppSelect';
import AppSwitch from '@nxsys/components/AppSwitch';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { getSalaryCalculationMethodOptions } from '@nxsys/utils';
import { Col, Form, Row } from 'antd';
import React from 'react';
import type { PayrollFinanceSectionProps } from './types';
import { useSelector } from 'react-redux';
import { AppState } from '@nxsys/store';
import { IRELAND } from '@nxsys/store/constants/keys';

import AppRateInput from '@nxsys/components/AppRateInput';

const PaymentModelSection: React.FC<PayrollFinanceSectionProps> = ({
  watchValues,
  visibility,
}) => {
  const { messages } = useTypedIntl();
  // NX-5228: Take Home %, Salary Calculation Method and Hours Cap are PAYE
  // FTH (Fixed Take Home) settings — a UK-only payment model.
  const { payrollCountry } = useSelector((state: AppState) => state.appStore);
  const isIreland = payrollCountry === IRELAND;
  const salaryCalculationMethodOptions = getSalaryCalculationMethodOptions();

  if (!visibility.paymentModel || isIreland) return null;

  return (
    <div className="pt-6">
      <div className="mb-6 text-xl font-medium text-gray-800">
        {messages['common.paymentModel']}
      </div>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label={messages['common.takeHomePercent']}
            name={['tracking', 'takeHomePercent']}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <AppRateInput placeholder={messages['form.enter']} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label={messages['common.salaryCalculationMethod']}
            name={['tracking', 'salaryCalMethod']}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <AppSelect
              options={salaryCalculationMethodOptions}
              placeholder={messages['form.enter']}
            />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            label={messages['common.marginUmbrellaAdvanceAdjustment']}
            name={['tracking', 'marginUmbrellaAdvanceAdjustment']}
            labelCol={{ span: 20 }}
            wrapperCol={{ span: 4 }}
          >
            <AppSwitch />
          </Form.Item>
        </Col>
        <Col span={12}>
          {watchValues?.tracking?.salaryCalMethod?.value === 'HOURS_CAP' && (
            <Form.Item
              label={messages['common.hoursCap']}
              name={['tracking', 'hoursCap']}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <AppRateInput placeholder={messages['form.enter']} />
            </Form.Item>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PaymentModelSection;
